import { action } from 'satcheljs/lib/legacy';
import store from '../store/store';
import getMailboxCalendarConfiguration from '../services/getMailboxCalendarConfiguration';

export default action('initCalendarMailboxConfiguration')(
    async function initCalendarMailboxConfiguration() {
        if (store.calendarConfiguration) {
            // If we already have the mailbox configuration, we won't get it again
            return;
        }

        store.calendarConfiguration = await getMailboxCalendarConfiguration();
    }
);
